import React, { useState, useEffect } from 'react';
import { Button, Form, Input, Layout, Typography, message } from 'antd';
import QuizResultApi from 'api/v3/quiz_result';
import { PdUploader } from 'components/pd-uploader';
import { hasFormErrors } from 'utils';
import { PageSpinner } from 'components/page-spinner';

import ReactQuill from 'react-quill';

import _ from 'lodash';

const { Header, Content } = Layout;
const { Title } = Typography;

const FIELDS = {
  TITLE: 'title',
  DESCRIPTION: 'description',
  BUTTON_TEXT: 'button_text',
  BUTTON_URL: 'button_url',
  HEADER_BUTTON_URL: 'header_button_url',
  WHATSAPP_TEXT: 'whatsapp_text',
  WHATSAPP_URL: 'whatsapp_url',
  MEDIA_URL: 'media_url',
};

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];

function QuizResult(props) {
  const [content, setContent] = useState({});
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);

  const { form } = props;

  const { getFieldDecorator, getFieldsError } = form;

  const getContent = async () => {
    setLoadingPage(true);
    try {
      const res = await QuizResultApi.get();
      const data = _.get(res, 'data.data');

      // use only key declared in FIELDS
      setContent(_.pick(data, Object.values(FIELDS)));
    } catch (err) {
      const errMessage = _.get(err, 'response.data.message');
      message.error(errMessage || 'Cannot connect to the server');
    } finally {
      setLoadingPage(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (!err) {
        try {
          setLoadingButton(true);
          // avoid overfetch and unwanted mutation
          const payload = _.pick(
            { ...content, ...values },
            Object.values(FIELDS)
          );
          await QuizResultApi.update(payload);
          message.success('Data has been updated');
        } catch (err) {
          const errMessage = _.get(err, 'response.data.message');
          message.error(errMessage || 'Cannot connect to the server');
        } finally {
          setLoadingButton(false);
        }
      }
    });
  };

  useEffect(() => {
    getContent();
  }, []);

  if (loadingPage) {
    return <PageSpinner />;
  }

  return (
    <Layout className="pd-cms-video-section pd-cms-form-1">
      <Header>
        <Title>Quiz Result A</Title>
      </Header>
      <Content>
        <Form onSubmit={handleSubmit}>
          <Form.Item label="Title">
            {getFieldDecorator(FIELDS.TITLE, {
              initialValue: content[FIELDS.TITLE],
            })(<Input placeholder="Enter headline" />)}
          </Form.Item>

          <Form.Item label="Description">
            {getFieldDecorator(FIELDS.DESCRIPTION, {
              rules: [{ required: true, message: 'Please input description!' }],
              initialValue: content[FIELDS.DESCRIPTION] || '',
            })(
              <ReactQuill
                placeholder="Write your content here"
                modules={modules}
                formats={formats}
              />
            )}
          </Form.Item>

          <Form.Item label="Button Text">
            {getFieldDecorator(FIELDS.BUTTON_TEXT, {
              initialValue: content[FIELDS.BUTTON_TEXT],
            })(<Input placeholder="Enter button text" />)}
          </Form.Item>

          <Form.Item label="Button URL">
            {getFieldDecorator(FIELDS.BUTTON_URL, {
              initialValue: content[FIELDS.BUTTON_URL],
            })(<Input placeholder="Enter button url" />)}
          </Form.Item>

          <Form.Item label="Header Button URL">
            {getFieldDecorator(FIELDS.HEADER_BUTTON_URL, {
              initialValue: content[FIELDS.HEADER_BUTTON_URL],
            })(<Input placeholder="Enter header button url" />)}
          </Form.Item>

          <Form.Item label="Whatsapp Text">
            {getFieldDecorator(FIELDS.WHATSAPP_TEXT, {
              initialValue: content[FIELDS.WHATSAPP_TEXT],
            })(<Input placeholder="Enter button text" />)}
          </Form.Item>

          <Form.Item label="Whatsapp URL">
            {getFieldDecorator(FIELDS.WHATSAPP_URL, {
              initialValue: content[FIELDS.WHATSAPP_URL],
            })(<Input placeholder="Enter button URL" />)}
          </Form.Item>

          <Form.Item label="Picture">
            <PdUploader
              purpose="quiz_video"
              afterUpload={(url) => {
                setContent((prevState) => ({
                  ...prevState,
                  [FIELDS.MEDIA_URL]: url,
                }));
              }}
              imgUrl={content[FIELDS.MEDIA_URL]}
            />
          </Form.Item>

          <Form.Item>
            <Button
              className="btn-full"
              type="primary"
              htmlType="submit"
              loading={loadingButton}
              disabled={hasFormErrors(getFieldsError())}>
              Publish
            </Button>
          </Form.Item>
        </Form>
      </Content>
    </Layout>
  );
}

export const QuizResultForm = Form.create({
  name: 'quiz_intro_content',
})(QuizResult);
